__webpack_require__.p = "https://conference.smdc.edu.pk/";